import '@babel/polyfill'
import './plugins/vuetify'
import 'dragula/dist/dragula.css'
import './stylus/main.styl'
import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue'
import App from './App.vue'

import VueCarousel from 'vue-carousel'
Vue.use(VueCarousel);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

export const eventBus = new Vue();

// Import all components in pages

const req = require.context('./pages/', true, /\.(js|vue)$/i);
req.keys().map(key => {
  const name = key.match(/\w+/)[0];
  return Vue.component(name, req(key).default)
});

export var globalStore = new Vue({
  data: {
    totalPages: req.keys().length
  }
})

import Breadcrumb from './components/Breadcrumb.vue'
import L_Progress from './components/LessonProgress.vue'
import Editable from './components/Editable.vue'


import { Vue2Dragula } from 'vue2-dragula'
Vue.use(Vue2Dragula, {
  logging: {
    directive: true,
    plugin: true,
    service: true,
    dragHandler: true,
    modelManager: true
  }
})

Vue.config.debug = true

//components
Vue.component('breadcrumb', Breadcrumb);
Vue.component('l-progress', L_Progress);
Vue.component('editable', Editable);

window.App = new Vue({
  el: '#app',
  render: h => h(App)
})
